import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { modalClasses } from '../modal.classes';
import { useModalBodyFullScrollStyles } from './modalBody.styles';
/**
 * The scrollable content area of the Modal.
 * The entire modal body is scrollable with specific styles applied.
 */ export const ModalBodyFullScroll = ({ styles, withFooter = true, onRefChanged, children })=>{
    const [modalBody, setModalBody] = useState(null);
    const css = useModalBodyFullScrollStyles(modalBody, withFooter);
    useEffect(()=>{
        if (modalBody) {
            onRefChanged?.(modalBody);
        }
    }, [
        modalBody
    ]);
    return /*#__PURE__*/ _jsx(Box, {
        ref: setModalBody,
        className: modalClasses.body,
        style: styles,
        css: css.body,
        children: children
    });
};

//# sourceMappingURL=modalBodyFullScroll.js.map